<template lang="pug">
filter-detail-container(
  :title="$t('filter_age')"
  @back="back"
  @save="save"
)
  template(v-slot:body)
    .pa-6
      .mb-4 {{ $t('filter_age_with_value') }}:
      yc-select.mt-4(v-model="condition" :items="options")
      yc-text-field.mt-4(:label="$t('enter_value')" v-model="age" type="number")
      .ma-2.text-xs.primary400--text {{ $t('value_must_be_in_number') }}
</template>

<script>
import FilterDetailContainer from './FilterDetailContainer.vue'

export default {
  props: ['filter'],
  components: { FilterDetailContainer },
  data: () => ({
    age: null,
    condition: 'more',
    options: [
      { id: 'more', label: 'Older than' },
      { id: 'less', label: 'Younger than' },
      { id: 'equal', label: 'Exact age' }
    ],
  }),
  created() {
    const { more, less, equal } = this.filter
    if (more) {
      this.condition = 'more'
      this.age = more
    }
    if (less) {
      this.condition = 'less'
      this.age = less
    }
    if (equal) {
      this.condition = 'equal'
      this.age = equal
    }
  },
  methods: {
    save() {
      const filter = this.getFilterData()
      this.$emit('update:filter', filter)
      this.back()
    },
    getFilterData() {
      switch (this.condition) {
        case 'more':
          return { more: this.age }
        case 'less':
          return { less: this.age }
        case 'equal':
          return { equal: this.age }
        case 'between':
          return { between: this.age }
        default:
          return {}
      }
    },
    back() {
      this.$emit('onBack')
    }
  }
}
</script>